'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BlockUi = require('./BlockUi');

var _BlockUi2 = _interopRequireDefault(_BlockUi);

var _reduxMiddleware = require('./reduxMiddleware');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReduxBlockUi = function (_Component) {
  (0, _inherits3.default)(ReduxBlockUi, _Component);

  function ReduxBlockUi(props) {
    (0, _classCallCheck3.default)(this, ReduxBlockUi);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.middleware = _this.middleware.bind(_this);

    _this.blocking = 0;
    _this.state = {
      blocking: 0
    };
    return _this;
  }

  ReduxBlockUi.prototype.middleware = function middleware(action) {
    var _props = this.props,
        block = _props.block,
        unblock = _props.unblock;


    this.checkAction(action, block);
    this.checkAction(action, unblock, false);
  };

  ReduxBlockUi.prototype.checkAction = function checkAction(action, check) {
    var _this2 = this;

    var block = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (check) {
      if (!Array.isArray(check)) {
        check = [check];
      }

      check.forEach(function (value) {
        var result = void 0;
        if (typeof value === 'function') {
          result = value(action);
        } else if (value instanceof RegExp) {
          value.lastIndex = 0;
          result = value.test(action.type);
        } else {
          result = value === action.type;
        }

        if (result === true) {
          var oldValue = _this2.blocking;

          if (block) {
            _this2.setState({ blocking: ++_this2.blocking });
          } else {
            if (_this2.blocking < 1) {
              _this2.blocking = 0;
            } else {
              --_this2.blocking;
            }
            _this2.setState({ blocking: _this2.blocking });
          }

          _this2.props.onChange && _this2.props.onChange(_this2.blocking, oldValue);
        }
      });
    }
  };

  ReduxBlockUi.prototype.componentWillMount = function componentWillMount() {
    (0, _reduxMiddleware.register)(this.middleware);
  };

  ReduxBlockUi.prototype.componentWillUnmount = function componentWillUnmount() {
    (0, _reduxMiddleware.unregister)(this.middleware);
  };

  ReduxBlockUi.prototype.render = function render() {
    var _props2 = this.props,
        blocking = _props2.blocking,
        block = _props2.block,
        unblock = _props2.unblock,
        onChange = _props2.onChange,
        attributes = (0, _objectWithoutProperties3.default)(_props2, ['blocking', 'block', 'unblock', 'onChange']);


    return _react2.default.createElement(_BlockUi2.default, (0, _extends3.default)({}, attributes, { blocking: blocking || this.state.blocking > 0 }));
  };

  return ReduxBlockUi;
}(_react.Component);

ReduxBlockUi.propTypes = {
  blocking: _propTypes2.default.bool,
  block: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(RegExp), _propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.func]),
  unblock: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(RegExp), _propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.func]),
  onChange: _propTypes2.default.func
};
exports.default = ReduxBlockUi;